const KEY = "ss_cart";
export const readCart = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
export const writeCart = (lines) => { localStorage.setItem(KEY, JSON.stringify(lines)); window.dispatchEvent(new Event("ss-cart-updated")); };
export const addToCart = (draftId) => { const c = readCart(); if (!c.some((l) => l.draftId === draftId)) writeCart([...c, { draftId }]); };
export const clearCart = () => writeCart([]);
